import Container from "../../layout/Container";
import Card from "../../ui/Card";
import { useLanguage } from "../../../i18n/LanguageContext";

// SVG icons 
const icons = {
  eye: (
    <svg viewBox="0 0 24 24" fill="none" stroke="#ff4b32" strokeWidth="2">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  ),
  mail: (
    <svg viewBox="0 0 24 24" fill="none" stroke="#ff4b32" strokeWidth="2">
      <path d="M4 4h16v16H4z" />
      <polyline points="22,6 12,13 2,6" />
    </svg>
  ),
  target: (
    <svg viewBox="0 0 24 24" fill="none" stroke="#ff4b32" strokeWidth="2">
      <circle cx="12" cy="12" r="10" />
      <circle cx="12" cy="12" r="6" />
      <circle cx="12" cy="12" r="2" />
    </svg>
  ),
};

export default function ValuesPreview() {
  const { t } = useLanguage();
  const valuesData = t.home.valuesPreview.cards;
  return (
    <section className="values">
      <Container>
        {/* Section title */}
        <h2 className="values__title">{t.home.valuesPreview.title}</h2>

        {/* Subtitle */}
        <p className="values__subtitle">
          {t.home.valuesPreview.subtitle}
        </p>

        {/* Cards grid */}
        <div className="values__grid">
          {valuesData.map((item, index) => (
            <div
              key={index}
              className="value-card-wrapper"
              data-aos="fade-up"
              data-aos-delay={index * 150}
            >
              {/* Icon ABOVE the card */}
              <div className="value-card-icon">
                {icons[item.icon]}
              </div>

              {/* Reusing shared Card component */}
              <Card
                className="service-card"
                title={item.title}
                description={item.desc}
              />
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}